import { Injectable } from '@angular/core';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

/**
 * Token Storage Service
 *
 * Manages JWT tokens in localStorage for persistence across page refreshes.
 * Tokens are cleared immediately on logout (no API wait required).
 */
@Injectable({
	providedIn: 'root',
})
export class TokenStorageService {
	saveTokens(accessToken: string, refreshToken: string): void {
		localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
		localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
	}

	getAccessToken(): string | null {
		return localStorage.getItem(ACCESS_TOKEN_KEY);
	}

	getRefreshToken(): string | null {
		return localStorage.getItem(REFRESH_TOKEN_KEY);
	}

	clearTokens(): void {
		localStorage.removeItem(ACCESS_TOKEN_KEY);
		localStorage.removeItem(REFRESH_TOKEN_KEY);
	}

	hasTokens(): boolean {
		return !!this.getAccessToken() && !!this.getRefreshToken();
	}
}